import http from "../../utils/http"

/**
 * 获取分销团队列表
 */
export function fenxiaoTeam(params) {
    return http({
        url: "/fenxiao/api/fenxiao/team",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取分销基本配置
 */
export function fenxiaoConfig(params) {
    return http({
        url: "/fenxiao/api/config/basics",
        data: params
    })
}

/**
 * 获取分销详情信息
 */
export function fenxiaoDetail(params) {
    return http({
        url: "/fenxiao/api/fenxiao/detail",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取团队数量统计
 */
export function fenxiaoTeamNum(params) {
    return http({
        url: "/fenxiao/api/fenxiao/teamnum",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取提现配置
 */
export function withdrawConfig(params) {
    return http({
        url: "/fenxiao/api/config/withdraw",
        data: params,
        forceLogin: true
    })
}

/**
 * 提现申请
 */
export function withdrawApply(data) {
    return http({
        url: "/fenxiao/api/withdraw/apply",
        method: "post",
        data: data,
        forceLogin: true
    })
}

/**
 * 获取提现记录列表
 */
export function withdrawList(params) {
    return http({
        url: "/fenxiao/api/withdraw/page",
        data: params,
        forceLogin: true
    })
}